<template>
  <div class="noWrap">
    {{ setLabel }}
  </div>
</template>

<script>
export default {
  name: 'ProductTypeValueColumn',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    getValue() {
      return this.value;
    },
    setLabel() {
      return this.getValue === 'F' ? 'Fixo' : 'Percentual';
    },
  },
};
</script>
